var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9837 5.93633L9.82195 4.86472C9.62818 4.83102 9.50761 5.06828 9.64906 5.20493L15.0092 10.3834C15.0481 10.421 15.0701 10.4728 15.0701 10.5269V29.7389C15.0701 29.7814 15.0836 29.8227 15.1087 29.8569L16.0552 31.1476C16.1183 31.2336 16.2379 31.2548 16.3267 31.1957L27.6289 23.6771C27.7207 23.616 27.7456 23.4921 27.6845 23.4003L16.1156 6.02237C16.0853 5.97681 16.0376 5.9457 15.9837 5.93633Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5821 2.18265L10.395 3.62822C10.1921 3.68476 10.2038 3.97624 10.4105 4.01644L16.685 5.23648C16.7373 5.24666 16.7834 5.27734 16.813 5.3217L26.9777 20.5687C27.0574 20.6883 27.2335 20.687 27.3114 20.5662L32.1286 13.1044C32.1882 13.012 32.1619 12.8888 32.0697 12.8288L15.7445 2.20762C15.6965 2.17636 15.6373 2.16726 15.5821 2.18265Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0086 10.6824L7.22097 4.37963C7.14478 4.30888 7.02705 4.30846 6.95036 4.37867L0.0648221 10.6823C0.0235203 10.7201 0 10.7736 0 10.8296V31.8004C0 31.9106 0.0893681 32 0.199609 32H13.8728C13.983 32 14.0724 31.9106 14.0724 31.8004V10.8287C14.0724 10.7732 14.0493 10.7202 14.0086 10.6824Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 19.0586L10.1138 12.8042Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 19.0586L10.1138 12.8042",
    stroke: "white",
    strokeWidth: 0.598826,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52765 13.0904C5.90929 13.4721 5.90929 14.0908 5.52765 14.4725C5.14601 14.8541 4.52724 14.8541 4.1456 14.4725C3.76397 14.0908 3.76397 13.4721 4.1456 13.0904C4.52724 12.7088 5.14601 12.7088 5.52765 13.0904Z",
    stroke: "white",
    strokeWidth: 0.598826,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8265 17.3905C10.2081 17.7721 10.2081 18.3909 9.8265 18.7725C9.44486 19.1542 8.82607 19.1542 8.44443 18.7725C8.06279 18.3909 8.06279 17.7721 8.44443 17.3905C8.82607 17.0088 9.44486 17.0088 9.8265 17.3905Z",
    stroke: "white",
    strokeWidth: 0.598826,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.59375,
    y: 20.9218,
    width: 8.98239,
    height: 0.598826,
    rx: 0.299413,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.59375,
    y: 23.1174,
    width: 6.58709,
    height: 0.598826,
    rx: 0.299413,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.59375,
    y: 25.3131,
    width: 6.58709,
    height: 0.598826,
    rx: 0.299413,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.59375,
    y: 27.5088,
    width: 6.58709,
    height: 0.598826,
    rx: 0.299413,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.58203,
    y: 23.1174,
    width: 1.99609,
    height: 0.598826,
    rx: 0.299413,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.58203,
    y: 25.3131,
    width: 1.99609,
    height: 0.598826,
    rx: 0.299413,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.58203,
    y: 27.5088,
    width: 1.99609,
    height: 0.598826,
    rx: 0.299413,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13814 0.960863C8.87995 0.997922 10.0398 1.89793 10.4899 2.43929C10.5467 2.5077 10.6392 2.5375 10.7232 2.50811L11.3449 2.29052C11.4653 2.24836 11.5156 2.10561 11.4379 2.00443C10.8632 1.25663 9.78778 0.640927 9.28399 0.411933C7.82018 -0.153625 4.42344 -0.57616 2.54716 2.25831C0.859928 4.8072 1.66508 7.31145 2.41878 8.33519C2.48575 8.42615 2.61567 8.43215 2.69824 8.35507L3.17411 7.91092C3.24453 7.84519 3.25724 7.73832 3.20837 7.6553C2.05809 5.70117 2.87699 3.65289 3.44538 2.85715C3.8945 2.20842 5.26182 0.920941 7.13814 0.960863Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.4b599d1644054bc77b19d5935a5afc49.svg";
export { ForwardRef as ReactComponent };